export const API_GET_NB_KEEPERS_FOR_PUSH_NOTIFICATIONS = "API_GET_NB_KEEPERS_FOR_PUSH_NOTIFICATIONS"
export const API_SEARCH_TEST_KEEPER = "API_SEARCH_TEST_KEEPER"
export const API_SEND_TEST_PUSH_NOTIFICATION = "API_SEND_TEST_PUSH_NOTIFICATION"
export const API_SEND_PUSH_NOTIFICATIONS = "API_SEND_PUSH_NOTIFICATIONS"
export const API_SEND_PUSH_NOTIFICATIONS_TO_KEEPER_IDS = "API_SEND_PUSH_NOTIFICATIONS_TO_KEEPER_IDS"
